export const QueryKeys = {
    GetRoles: 'get-roles',
    GetRolesSingle: 'get-roles-single',
}
